import { v4 } from 'uuid';
import axios from 'axios';
import { axiosRetryInstances, axios as nppClient } from '../client/base';
import { axios as gaClient } from '../client/api-google-analytics';

export const SessionIdHeader = 'X-Session-Id';
export const PaymentIdHeader = 'X-Payment-Id';
export let Session: string;

type AuditInterceptorsAxiosRequestConfig = { headers?: any; url?: string };
type AuditInterceptorsAxiosInstance = {
  interceptors: {
    request: {
      use(
        onFulfilled?: (
          value: AuditInterceptorsAxiosRequestConfig
        ) => AuditInterceptorsAxiosRequestConfig
      ): any;
    };
  };
};

// endpoints that are called in a loop need header to not be blocked by Akamai
export const shouldIncludePaymentIdHeader = (url?: string): boolean => {
  if (!url) return false;
  return (
    /\/api\/payment\/status(\?|$)/.test(url) ||
    /\/api\/[^/]+\/enforceStatusCheck/.test(url) ||
    /\/api\/[^/]+\/verifyTransactions?(\?|\/|$)/.test(url)
  );
};

export const setAxiosHeaders = (sessionId: string, paymentId?: string): void => {
  const clients = [axios, nppClient, gaClient, ...axiosRetryInstances];
  if (!sessionId) {
    sessionId = generateNewUuid();
  }
  Session = sessionId;
  for (const client of clients) {
    (client as AuditInterceptorsAxiosInstance).interceptors.request.use((config) => {
      config.headers[SessionIdHeader] = sessionId;

      if (paymentId && shouldIncludePaymentIdHeader(config.url)) {
        config.headers[PaymentIdHeader] = paymentId;
      }

      return config;
    });
  }
};

const generateNewUuid = (): string => {
  return v4();
};
